import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { Option } from 'src/app/settings/model/value-field';

@Component({
  selector: 'app-option-check-list',
  templateUrl: './option-check-list.component.html',
  styleUrls: ['./option-check-list.component.scss']
})
export class OptionCheckListComponent implements OnChanges {

  @Input() options: Option[] = [];
  @Input() filter = '';
  @Input() value: string[] = [];

  @Output() valueChange: EventEmitter<string[]> = new EventEmitter();

  filtered: Option[] = [];

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.options || changes.filter) this.applyFilter();
  }

  get selectedCount(): number {
    return this.value?.length ?? 0;
  }

  get allFilteredSelected(): boolean {
    return !!this.filtered.length && this.filtered.every(option => this.isSelected(option));
  }

  isSelected(option: Option): boolean {
    return !!this.value?.includes(option.value);
  }

  toggle(option: Option): void {
    const value = this.value ?? [];
    this.valueChange.emit(this.isSelected(option)
      ? value.filter(selected => selected !== option.value)
      : [...value, option.value]);
  }

  toggleAllFiltered(): void {
    const value = this.value ?? [];
    const filtered = this.filtered.filter(option => !option.disabled).map(option => option.value);
    this.valueChange.emit(this.allFilteredSelected
      ? value.filter(selected => !filtered.includes(selected))
      : [...value, ...filtered.filter(option => !value.includes(option))]);
  }

  trackByValue(_index: number, option: Option): string {
    return option.value;
  }

  private applyFilter(): void {
    const phrase = (this.filter ?? '').trim().toLowerCase();
    this.filtered = (this.options ?? []).filter(option => option.key.toLowerCase().includes(phrase));
  }
}
